import { CONFs, URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const financial = {
    get: {
        // @Url /v1/payment/{cbidx}/bank-trans-list
        bankTransList: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/bank-trans-list`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/client-list
        clientList: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/client-list`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-incexp-list
        resolutionIncexpList: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-incexp-list`, {
                params: params
            }
            )
        },
        // @Url  /v1/payment/{cbidx}/resolution-slip-list
        accountBookResolution: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-slip-list`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/financial-account-report
        accountReport: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/financial-account-report`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/general-ledger-list
        generalLedgerList: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/general-ledger-list`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/account-book-list
        accountBookList: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/account-book-list`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract-list
        taxRepresentContract: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract-list`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract
        representContract: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/dash
        dash: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/dash`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/dash-year
        dashYear: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/dash-year`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-inc-exp-deposit
        resolutionIncExpDeposit: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-inc-exp-deposit`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/client-account-item-trans
        clientAccountItemTrans: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/client-account-item-trans`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-staff-payslip
        resolutionStaffPayslip: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/resolution-staff-payslip`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/receiver-deposit
        regReceiverDeposit: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/receiver-deposit`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/bank-trans-deposit
        bankTransDeposit: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/bank-trans-deposit`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/client-account-match
        listOfClientMatchingAccount: async (params) => {
            return await http.get(
                `${URLs.payment}/${params.cbidx}/client-account-match`, {
                params: params
            }
            )
        },
        // @Url /v1/sync/task-log
        getTaskLogReport: async (params) => {
            return await http.get(
                `${URLs.sync}/task-log`, { params: params }
            )
        },
        // @Url /v1/sync/task-log/types
        getTaskSelectType: async (params) => {
            return await http.get(
                `${URLs.sync}/task-log/types`, { params: params }
            )
        },
        /**
         * 
         * @param {object} params 
         * @comment
         * getPaymentLedger - 장부 리스트를 조회
         * getPaymentLedger/idx - 하나의 장부만 조회 
         */
        // @Url /v2/payment/payment-ledger
        getPaymentLedger: async (params) => {
            return await http.get(
                `/v2/payment/payment-ledger`, { params: params }
            )
        },
        // @Url /v2/payment/payment-ledger/{ledgerIdx}
        getThePaymentLedgerBook: async (params) => {
            return await http.get(
                `/v2/payment/payment-ledger/${params.ledgerIdx}`, { params: params }
            )
        },
        /**
         * @brief 장부 상세내역 가져오기
         * @param {Object} params - cbidx, ledgerIdx
         * @returns {Object} res.data
         * @comment 2번은 사용하지 않는다. 1번을 사용하는데 2번도 동작하도록 한 것이다.
         * *1.endpoint - /v2/payment/payment-ledger/{ledgerIdx}/resolution-list
         * 2.endpoint - /v2/payment/payment-ledger/{resolutionIncomeExpenseLedgerIdx}/resolution-list
         */
        getLedgerBookDetail: async (params) => {
            return await http.get(
                `/v2/payment/payment-ledger/${params.ledgerIdx}/resolution-list`,
                { params: params }
            )
        },
        /**
         * @brief 선택되는 은행계좌의 거래내역 12개월을 불러온다. 
         * @param {object} params - cbidx, selectYear
         * @returns {object} res.data
         */
        // @Url /v2/payment/bank-trans-list
        bankTrans12MonthList: async (params) => {
            return await http.get(
                `/v2/payment/bank-trans-list`, {
                params: params
            })
        },
        // @Url /v1/sync/sync-info/{syncInfoIdx}
        syncingCurrentStatus: async (params) => {
            return await http.get(
                `${URLs.sync}/sync-info/${params.syncInfoIdx}`, {
                params: params
            })
        },
        // 현금출납부 : /v2/payment/cash-book
        cashFlowBook: async (params) => {
            return await http.get(
                `/v2/payment/cash-book`, {
                params: params
            })
        },
        // 총계정원장I : /v2/payment/general-ledger-type1
        generalLedgerBookI: async (params) => {
            return await http.get(
                `/v2/payment/general-ledger-type1`, {
                params: params
            })
        },
        // 총계정원장II : /v2/payment/general-ledger
        generalLedgerBookII: async (params) => {
            return await http.get(
                `/v2/payment/general-ledger`, {
                params: params
            })
        },
        // 상대계정 : /v2/payment/correspond-account
        correspondAccountBook: async (params) => {
            return await http.get(
                `/v2/payment/correspond-account`, {
                params: params
            })
        },
        // 월별손익분석표 : @Url /v2/payment/monthly-profit-loss
        monthlyProfitLossBook: async (params) => {
            return await http.get(
                `/v2/payment/monthly-profit-loss`, {
                params: params
            })
        },
        // 전년도이월금 목록 : @Url /v1/budget/prev-year-carryover
        fetchPrevYearCarryoverList: async (params) => {
            return await http.get(URLs.budget.prevYearCarryover, { params: params })
        },
        // 전년도이월금 단건 : @Url /v1/budget/prev-year-carryover/{idx}
        fetchPrevYearCarryoverOne: async (params) => {
            return await http.get(`${URLs.budget.prevYearCarryover}/${params.idx}`)
        },
        // 자동 불러오기 : @Url /v1/budget/prev-year-carryover/auto-calc
        fetchPrevYearCarryoverAutoCalc: async (params) => {
            return await http.get(`${URLs.budget.prevYearCarryover}/auto-calc`, { params: params })
        },
        // 결의서 장부 존재 체크 : @Url /v1/budget/prev-year-carryover/check-resolution-ledger
        checkResolutionLedgerExists: async (params) => {
            return await http.get(`${URLs.budget.prevYearCarryover}/check-resolution-ledger`, { params: params })
        },
    },
    post: {
        // @Url /v1/customers/{cbidx}/sync-bank-transaction
        syncBankTransaction: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.customer}/${params.cbidx}/sync-bank-transaction`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-client-memo 
        resolutionClientMemo: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-client-memo`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-servicetpye 
        resolutionServiceType: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-servicetpye`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/req-resolution-confirm 
        resolutionConfirm: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/req-resolution-confirm`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-journalize
        resolutionJournalize: async (params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-journalize`,
                params.resieDTO, {
                params: {
                    luidx: params.luidx,
                    cbidx: params.cbidx,
                    resieIdx: params.resieIdx
                }
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-file-upload
        resolutionFile: async (params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-file-upload`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract
        taxRepresentContract: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract-file
        taxRepresentContractFile: async (params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract-file`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-client-memo-multi
        clientMemoMulti: async (params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-client-memo-multi`,
                params.clientMemoDTO, {
                params: {
                    luidx: params.luidx,
                    cbidx: params.cbidx
                }
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-w4c-apply
        W4CApply: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-w4c-apply`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/bank-trans-memo-multi
        bankTransMemo: async (params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/bank-trans-memo-multi`,
                params.bankDTO, {
                params: {
                    luidx: params.luidx,
                    cbidx: params.cbidx
                }
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-chg-client-memo-confirm
        resolutionChgConfirm: async (params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-chg-client-memo-confirm`,
                params.clientDTO, {
                params: {
                    luidx: params.luidx,
                    cbidx: params.cbidx,
                    startYmd: params.startYmd,
                    endYmd: params.endYmd
                }
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-job-flag
        resolutionJobFlag: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-job-flag`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/tax-report-req
        taxReportReq: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/tax-report-req`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/reg-receiver-deposit
        regReceiverDeposit: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/reg-receiver-deposit`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/depositor-resie-chg
        depositorResieChg: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/depositor-resie-chg`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/match-receiver-deposit
        matchReceiverDeposit: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/match-receiver-deposit`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/depositor-receiver-chg
        depositorReceiverChg: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/depositor-receiver-chg`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-ie/iedoc-salary-reg
        iedocSalaryReg: async (params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-ie/iedoc-salary-reg`,
                params.resSalaryDTO, {
                params: {
                    luidx: params.luidx,
                }
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-ie/iedoc-salary-del
        iedocSalaryDel: async (params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-ie/iedoc-salary-del`, formData
            )
        },
        // @Url /v1/payment/{cbidx}/bank-trans-deposit
        bankTransDeposit: async (params) => {
            return await http.post(
                `${URLs.payment}/${params.cbidx}/bank-trans-deposit`,
                params.bankTransDepositList, {
                params: {
                    luidx: params.luidx,
                }
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-account-funds
        updateAccountNameFunds: async (params) => {
            console.log("send params:", params.dto)
            return await http.post(
                `${URLs.payment}/${params.cbidx}/resolution-account-funds`,
                [
                    ...params.dto
                ]
            )
        },
        // @Url /v2/payment/payment-ledger/{ledgerIdx}
        editPaymentLedgerBook: async (params) => {
            return await http.post(
                `/v2/payment/payment-ledger/${params.ledgerIdx}`,
                params
            )
        },
        // @Url /v2/payment/payment-ledger
        aAddLedgerBook: async (params) => {
            return await http.post(
                `/v2/payment/payment-ledger`,
                params
            )
        },
        // @Url /v2/payment/payment-ledger/bulk-update
        editLedgerBook: async (params) => {
            return await http.post(
                `/v2/payment/payment-ledger/bulk-update`,
                params
            )
        },
        // @Url /v2/payment/resolutions/copy
        copyEachBook: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/copy`,
                params
            )
        },
        // @Url /v2/payment/resolutions/move
        moveEachBook: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/move`,
                params
            )
        },
        // @Url /v2/payment/resolutions/duplicate
        duplicateLedgers: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/duplicate`,
                params
            )
        },
        // @URL /v2/payment/payment-ledger/send-ssis
        sendToH4E: async (params) => {
            return await http.post(
                `/v2/payment/payment-ledger/send-ssis`, params
            )
        },
        // @URL /v2/payment/resolutions/convert-account-class
        replaceInputsNOutputs: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/convert-account-class`,
                params
            )
        },
        // /v2/payment/resolutions/journalize
        splitaLedgerto2Ledgers: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/journalize`,
                params
            )
        },
        // @URL /v2/payment/resolutions/account-code
        replaceAccSubName: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/account-code`,
                params
            )
        },
        // @URL /v2/payment/resolutions/renumber
        renumberResolutions: async (params) => {
            return await http.post(
                `/v2/payment/resolutions/renumber`, params
            )
        },
        // @URL /v2/payment/bank_trans/reg-resolution
        createLedgerBook: async (params) => {
            return await http.post(
                `/v2/payment/bank_trans/reg-resolution`, params
            )
        },
        // @URL /v2/payment/bank_trans/reg-resolution-v2
        createLedgerBookV2: async (params) => {
            return await http.post(
                `/v2/payment/bank_trans/reg-resolution-v2`, params
            )
        },
        /**
         * @param {object} params syncStateCode, syncManageMemo
         * @returns {integer} sync-info-idx
         * @comment 2번은 테스트를 하기 위해서 등록
         * 1. /v1/sync/sync-info/state : where sync-state-code 상관없이 업데이트
         * 2. /v1/sync/sync-info/state-with-11 : where sync-state-code 11인 경우에만 업데이트
         */
        // @url /v1/sync/sync-info/state
        stopSyncStatusHold: async (params) => {
            return await http.post(
                `/v1/sync/sync-info/state`, params
            )
        },
        // @url /v1/sync/sync-info/state-with-11
        stopSyncStatusHoldWith11: async (params) => {
            return await http.post(
                `/v1/sync/sync-info/state-with-11`, params
            )
        },
        // 전년도이월금 등록 : @Url POST /v1/budget/prev-year-carryover
        createPrevYearCarryover: async (params) => {
            return await http.post(URLs.budget.prevYearCarryover, params)
        },
        // 결의서 수동 등록 : @Url POST /v2/payment/payment-ledger/{ledgerIdx}/resolutions
        createResolutionManual: async (ledgerIdx, data) => {
            return await http.post(`/v2/payment/payment-ledger/${ledgerIdx}/resolutions`, data)
        }
    },
    put: {
        // 전년도이월금 수정 : @Url PUT /v1/budget/prev-year-carryover/{idx}
        updatePrevYearCarryover: async (params) => {
            return await http.put(`${URLs.budget.prevYearCarryover}/${params.idx}`, {
                amount: params.amount,
                updateUserIdx: params.updateUserIdx,
            })
        }
    },
    delete: {
        // @Url DELETE /v2/payment/bank-transaction 은행거래내역 거래년월 기준 삭제
        bankTrans: async (params) => {
            return await http.delete(
                `/v2/payment/bank-transaction`, {
                data: params
            })
        },
        // @Url /v1/payment/{cbidx}/resolution-journal
        resolutionJournalize: async (params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/resolution-journal`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/resolution-file-upload
        resolutionFile: async (params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/resolution-file-upload`, {
                params: params
            }
            )
        },
        // @Url /v1/payment/{cbidx}/tax-represent-contract
        taxRepresentContract: async (params) => {
            return await http.delete(
                `${URLs.payment}/${params.cbidx}/tax-represent-contract`, {
                params: params
            }
            )
        },
        /**
         * @param {Object} params {ledgerIdx, cbidx}
         * @returns {Object} result
         * @async /v2/payment/payment-ledger
         * @comment 
         * - 주소 변경 : /v2/payment/payment-ledger/{ledgerIdx} -> /v2/payment/payment-ledger
         * - 변경 일자 : 25.11.01 문서는 받지 못했지만 추 후 받을 예정
         * - 25.11.06 : query string에서 body로 변경
         *   Body로 보낼 때에는 data: {} 형태로 작성 필요, 아니면 계속 query로 간다.
         */
        ledgerBookList: async (params) => {
            return await http.delete(`/v2/payment/payment-ledger`, {
                data: params
            })
        },
        // @Url /v2/payment/resolutions
        deleteLedgers: async (params) => {
            return await http.delete(`/v2/payment/resolutions`, {
                data: params
            })
        },
        // @URL /v2/payment/resolutions/reset-ssis
        resetSsisNumber: async (params) => {
            return await http.delete(
                `/v2/payment/resolutions/reset-ssis`, {
                data: params
            }
            )
        },
        // @Url /v2/payment/resolutions/journalize
        cancelCuttingLedgerToPastor: async (params) => {
            return await http.delete(`/v2/payment/resolutions/journalize`, {
                data: params
            })
        },
        // 전년도이월금 삭제 : @Url DELETE /v1/budget/prev-year-carryover/{idx}
        deletePrevYearCarryover: async (params) => {
            return await http.delete(`${URLs.budget.prevYearCarryover}/${params.idx}`)
        },
    }
}


// WEBPACK FOOTER //
// ./src/api/financial.js